export default __webpack_public_path__ + "static/media/Blooded Boots of the Clans.77f63352.jpg";